module.exports = __webpack_public_path__ + "img/unmute.37718f68.svg";